module.exports = __webpack_public_path__ + "static/media/watchlater-icon-light.f723a3f5.svg";